import { type ReactElement, createContext } from 'react';

export enum ToastAlertVariants {
  error = 'error',
  success = 'success',
  info = 'info',
}

export enum ToastAlertPosition {
  topLeft = 'topLeft',
  bottomLeft = 'bottomLeft',
  topRight = 'topRight',
  bottomRight = 'bottomRight',
}

export interface ToastProviderConfig {
  position: keyof typeof ToastAlertPosition;
  autoDismissDuration: number;
  maxVisibleToasts: number;
}

export interface Toast {
  id: string;
  title?: string;
  message?: string;
  subjectName?: string;
  action?: ReactElement;
  type: ToastAlertVariants;
  position?: keyof typeof ToastAlertPosition;
  config?: Partial<ToastProviderConfig>;
}

export type ToastWithoutID = Omit<Toast, 'id'>;
export type ToastPayload = Omit<Toast, 'id' | 'type'>;

export interface ToastContextProps {
  showAlert(props: ToastWithoutID): void;
  removeAlert(props: Toast['id']): void;
}

export const ToastContext = createContext<ToastContextProps>({
  showAlert: () => null,
  removeAlert: () => null,
});
